// extracted by mini-css-extract-plugin
export default {"player_width":"1000px","player_height":"562.5px","modal":"styles_modal__S5XzE","player":"styles_player__nsKnN"};